exports = module.exports = require("./node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "header {\n  text-align: center\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./styles.css
// module id = 144
// module chunks = 3